import { generatePatientInfoRouterConfig } from 'components/root/router/sharedConfigs';

import { PATIENT_DATABASE, PL } from '../../../../constants/accessToPages';

import PatientDatabase from './PatientDatabase';

export const patientDatabaseRouterConfig = {
  name: 'Patient Database',
  path: '/patient-database',
  component: PatientDatabase,
  access: [PATIENT_DATABASE],
  feature: 'patientDatabaseEnabled',
  inherited: [...generatePatientInfoRouterConfig(PL, PL)]
};
